export default "https://cdn-static.gokick.com/assets/e031f09406d9a12f4f19fb28fc50e3428375be91/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";